exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.showBigImg[data-v-7b64a3c4]{background:rgba(55,55,55,.6);top:0;left:0;right:0;bottom:0;position:fixed;z-index:2999\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/components/imageNode/child/showBigImg.vue"],"names":[],"mappings":";AACA,6BAA6B,6BAA6B,MAAM,OAAO,QAAQ,SAAS,eAAe,YAAY;CAClH","file":"showBigImg.vue","sourcesContent":["\n.showBigImg[data-v-7b64a3c4]{background:rgba(55,55,55,.6);top:0;left:0;right:0;bottom:0;position:fixed;z-index:2999\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b64a3c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/style-rem-loader??ref--1!./src/components/imageNode/child/showBigImg.vue
// module id = 1264
// module chunks = 2